<template>
  <div>
    <Titulo texto="SISTEMA DE ADMISIÓN ESCOLAR" />
    <div
      class="bg-white d-flex align-items-center justify-content-center px-2 py-4 p-lg-5 border border-2 border-azul-claro2 mx-3"
    >
      <div class="text-center">
        <FontAwesomeIcon icon="check" class="fa-3x text-success" />
        <div class="h3 text-success font-weight-bold mt-4">
          Comprobante descargado
        </div>
        <div
          class="p-3 m-2 col-auto alert alert-warning justify-content-center h5 d-none d-lg-block mt-4"
        >
          Ubica tu comprobante en la
          <strong>carpeta de descargas</strong> de tu navegador
        </div>
        <div
          class="p-3 m-2 col-auto alert alert-warning justify-content-center h5 d-block d-lg-none mt-4"
        >
          Ubica tu comprobante en las
          <strong>descargas</strong> de tu móvil
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PdfDocument } from "@/utils/pdfMake/constructorPDF";
import Titulo from "@/components/generales/Titulo";
import ApiResultado from "@/service/ApiResultado.js";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faCheck);

export default {
  name: "DescargarResultado",
  components: {
    Titulo,
    FontAwesomeIcon
  },
  data() {
    return {
      jwt: "",
      resultadoData: {},
      url: window.location.origin
    };
  },
  mounted() {
    this.comprobarJWT();
  },
  methods: {
    comprobarJWT() {
      this.jwt = this.$route.query.resultado;
      this.resultadoData = this.$route.params.datos;
      if (!this.resultadoData || this.resultadoData === "") {
        console.log("comprobar jwt if " + this.resultadoData);
        this.validarComprobante();
      } else {
        console.log("comprobar jwt else " + this.resultadoData);
        this.generateComprobante(this.resultadoData);
      }
    },
    async validarComprobante() {
      if (this.jwt) {
        let validar = await ApiResultado.validarResultado(this.jwt, this);
        if (validar) {
          console.log("validar comprobante " + validar);
          this.generateComprobante(validar);
        } else {
          this.$router.push({
            name: "ValidarResultado",
            query: {
              resultado: this.jwt
            }
          });
        }
      } else {
        this.$emit(
          "onError",
          "Ha ocurrido un error en el proceso. Vuelva a intentarlo.",
          "ERROR DE AUTORIZACIÓN",
          true,
          "Sae",
          "SISTEMA DE ADMISIÒN ESCOLAR"
        );
      }
    },
    generateComprobante(datos) {
      let nombreDocumento = `Comprobante Resultado ${datos.postulante.run}-${
        datos.postulante.dv
      }`;
      PdfDocument.init(datos);
      PdfDocument.setFolio(datos.id);
      console.log("tipoAsignacion " + datos.tipoAsignacion);
      switch (datos.tipoAsignacion) {
        case "ALGORITMO_PRIMERA_PREFERENCIA":
        case "ALGORITMO_PRIMERA_PREFERENCIA_BLOQUE":
          if (datos.estado === "ACEPTADO") {
            this.comprobanteAceptoResultado(datos);
          } else if (datos.estado === "ACEPTADO_DEFAULT") {
            this.comprobantePorOmision(datos);
          } else {
            this.comprobanteRechazaResultado(datos);
          }
          break;
        case "ALGORITMO_PREFERENCIA_N":
        case "ALGORITMO_PREFERENCIA_N_BLOQUE":
          if (datos.estado === "ACEPTADO") {
            this.comprobanteAceptoResultado(datos);
          } else if (datos.estado === "ACEPTADO_DEFAULT") {
            this.comprobantePorOmision(datos);
          } else if (datos.estado === "LISTA_ESPERA") {
            this.comprobanteAceptoResultadoYActivoListaEspera(datos);
          } else {
            this.comprobanteRechazaResultado(datos);
          }
          break;
        case "MATRICULA_ASEGURADA_PRIMERA_PREFERENCIA":
        case "MATRICULA_ASEGURADA_PREFERENCIA_N":
        case "MATRICULA_ASEGURADA_PRIMERA_PREFERENCIA_BLOQUE":
        case "MATRICULA_ASEGURADA_PREFERENCIA_N_BLOQUE":
          if (
            datos.tipoAsignacion ===
              "MATRICULA_ASEGURADA_PRIMERA_PREFERENCIA_BLOQUE" ||
            datos.tipoAsignacion == "MATRICULA_ASEGURADA_PREFERENCIA_N_BLOQUE"
          ) {
            if (datos.estado === "ACEPTADO") {
              this.comprobanteAceptoMantenerEstablecimientoActual(datos, true);
            } else if (datos.estado === "ACEPTADO_DEFAULT") {
              this.comprobantePorOmision(datos);
            } else if (datos.estado === "LISTA_ESPERA") {
              this.comprobanteAceptoEstablecimientoActualYActivoListaEspera(
                datos
              );
            } else {
              this.comprobanteRechazaEstablecimientoActual(datos);
            }
          } else {
            if (datos.estado === "ACEPTADO") {
              this.comprobanteAceptoMantenerEstablecimientoActual(datos);
            } else if (datos.estado === "ACEPTADO_DEFAULT") {
              this.comprobantePorOmision(datos);
            } else if (datos.estado === "LISTA_ESPERA") {
              this.comprobanteAceptoEstablecimientoActualYActivoListaEspera(
                datos
              );
            } else {
              this.comprobanteRechazaEstablecimientoActual(datos);
            }
          }
          break;
        case "CORRE_LISTA_ESPERA_PREFERENCIA_N":
        case "CORRE_LISTA_ESPERA_MATRICULA_ASEGURADA":
          this.comporbanteCorreListaEspera(datos);
          break;
        case "NO_CORRE_LISTA_ESPERA_PREFERENCIA_N":
          this.comporbanteNoCorreListaEsperaPreferenciaN(datos);
          break;
        case "NO_CORRE_LISTA_ESPERA_MATRICULA_ASEGURADA":
          this.comporbanteNoCorreListaEsperaMatriculaAsegurada(datos);
          break;
        case "CORRE_LISTA_ESPERA_SIN_ASIGNACION":
          if (datos.estado === "ACEPTADO") {
            this.comprobanteAceptoCorreListaEsperaSinAsinacion(datos);
          } else if (datos.estado === "ACEPTADO_DEFAULT") {
            this.comprobantePorOmision(datos);
          } else {
            this.comprobanteRechazaCorreListaEsperaSinAsinacion(datos);
          }
          break;
        case "ALGORITMO_PRIMERA_PREFERENCIA_FINAL":
        case "ALGORITMO_PREFERENCIA_N_FINAL":
          this.comprobanteAdmitidoPreferenciaComplementario(datos);
          break;
        case "MATRICULA_ASEGURADA_FINAL":
          this.comprobanteAdmitidoMatriculaAseguradaComplementario(datos);
          break;
        case "DISTANCIA_FINAL":
          this.comprobanteAdmitidoDistanciaComplementario(datos);
          break;
        case "SIN_ASIGNACION_FINAL":
          datos.periodo = 4;
          this.comprobanteSinAsignacionComplementario(datos);
          break;
        case "NO_CORRE_LISTA_ESPERA_SIN_ASIGNACION":
          datos.periodo = 4;
          this.comprobanteSinAsignacionPeriodosAnterioresNoParticiaComplementario(
            datos
          );
          break;
        default:
          if (datos.estado === "LISTA_ESPERA_AUTOMATICA") {
            this.comprobanteListaEsperaAutomatica(datos);
          }
          break;
      }
      PdfDocument.openSinglePage(nombreDocumento);
      PdfDocument.reset();
    },
    generarURLqr() {
      let origen = this.url;
      let urlQr = "";
      if (!origen) {
        origen = "http://nc-ext-ibraramo.mineduc.cl:8060/";
        urlQr = origen + "validar-resultado?resultado=" + this.jwt;
      } else {
        urlQr = origen + CONTEXT + "/validar-resultado?resultado=" + this.jwt;
      }
      return urlQr;
    },
    cabeceraComprobante(titulo, datos) {
      let apoderado = {
        rutApoderado: datos.runApoderado,
        dvApoderado: datos.dvApoderado,
        nombreApoderado: datos.nombreApoderado,
        paternoApoderado: datos.paternoApoderado,
        maternoApoderado: datos.maternoApoderado ? datos.maternoApoderado : ""
      };
      PdfDocument.createTitleOriginal(
        titulo,
        datos.fechaModificacion
          ? datos.fechaModificacion
          : "Sin fecha de Modificación",
        datos.id,
        true,
        datos.periodo
      );
      PdfDocument.createPostulante(datos.postulante);
      PdfDocument.createApoderado(apoderado);
    },
    comporbanteCorreListaEspera(datos) {
      let preferencia = datos.preferencias.find(pref => pref.admitido);
      PdfDocument.setTituloDerecha(datos.periodo, true);
      PdfDocument.createTitle(datos, true);
      PdfDocument.createBannerEstado(datos, "RESULTADO_LISTA_ESPERA_TIPO_A_2");
      PdfDocument.createPreferenciasResult(datos);
      PdfDocument.createBanner2(datos, "RESULTADO_LISTA_ESPERA_TIPO_A_2_C");
      PdfDocument.createDatosEstablecimiento(preferencia.establecimiento);
      PdfDocument.createBannerPostulacionFamiliar();
      PdfDocument.createQRyTextoImportant(
        this.generarURLqr(),
        "RESULTADO_LISTA_ESPERA_TIPO_A_2"
      );
      PdfDocument.createBannerInformacionFinal();
    },
    comporbanteNoCorreListaEsperaPreferenciaN(datos) {
      let preferencia = datos.preferencias.find(pref => pref.admitido);
      PdfDocument.setTituloDerecha(datos.periodo, true);
      PdfDocument.createTitle(datos, true);
      PdfDocument.createBannerEstado(datos, "RESULTADO_TIPO_A");
      PdfDocument.createPreferenciasResult(datos);
      PdfDocument.createBanner2(
        datos,
        "ADMITIDO_EN_PERIODO_PRINCIPAL_NO_CORRE_LE"
      );
      PdfDocument.createDatosEstablecimiento(preferencia.establecimiento);
      PdfDocument.createBannerPostulacionFamiliar();
      PdfDocument.createQRyTextoImportant(
        this.generarURLqr(),
        "RESULTADO_LISTA_ESPERA_TIPO_A"
      );
      PdfDocument.createBannerInformacionFinal();
    },
    comporbanteNoCorreListaEsperaMatriculaAsegurada(datos) {
      let preferencia = datos.preferencias.find(pref => pref.admitido);
      PdfDocument.setTituloDerecha(datos.periodo, true);
      PdfDocument.createTitle(datos, true);
      PdfDocument.createBannerEstado(
        datos,
        "RESULTADO_LISTA_ESPERA_TIPO_A_NO_CORRE"
      );
      PdfDocument.createPreferenciasResult(datos);
      PdfDocument.createBanner2(datos, "RESULTADO_LISTA_ESPERA_TIPO_A");
      PdfDocument.createDatosEstablecimiento(preferencia.establecimiento);
      PdfDocument.createBannerPostulacionFamiliar();
      PdfDocument.createQRyTextoImportant(
        this.generarURLqr(),
        "RESULTADO_LISTA_ESPERA_TIPO_A"
      );
      PdfDocument.createBannerInformacionFinal();
    },
    comprobanteAceptoCorreListaEsperaSinAsinacion(datos) {
      let preferencia = datos.preferencias.find(pref => pref.admitido);
      PdfDocument.setTituloDerecha(datos.periodo, true);
      PdfDocument.createTitle(datos, true);
      PdfDocument.createBannerEstado(datos, "RESULTADO_LISTA_ESPERA_TIPO_B");
      PdfDocument.createPreferenciasResult(datos);
      PdfDocument.createBanner2(datos, "RESULTADO_LISTA_ESPERA_TIPO_B");
      PdfDocument.createDatosEstablecimiento(preferencia.establecimiento);
      PdfDocument.createBannerPostulacionFamiliar();
      PdfDocument.createQRyTextoImportant(
        this.generarURLqr(),
        "RESULTADO_LISTA_ESPERA_TIPO_B"
      );
    },
    comprobanteRechazaCorreListaEsperaSinAsinacion(datos) {
      let preferencia = datos.preferencias.find(pref => pref.admitido);
      let datosComprobante = {
        titulo: "DATOS RESULTADO RECHAZADO",
        preferenciaAdmitido: preferencia,
        postulante: datos.postulante,
        fechaModificacion: datos.fechaModificacion,
        tipoDetalle: "rechazaResultadoListaEsperaSinAsignacion"
      };
      PdfDocument.setTituloDerecha(datos.periodo, true);
      PdfDocument.createTitle(datos, true);
      PdfDocument.createBannerEstado(datos, "RECHAZA_RESULTADO");
      PdfDocument.createPreferenciasResult(datos, false, true);
      PdfDocument.createBanner2(datos, "RESULTADO_LISTA_ESPERA_TIPO_B_2");
      PdfDocument.createBannerPostulacionFamiliar();
      PdfDocument.createQRyTextoImportant(
        this.generarURLqr(),
        "RESULTADO_LISTA_ESPERA_TIPO_C"
      );
      PdfDocument.createBannerInformacionFinal();
    },

    comprobanteAceptoResultado(datos) {
      let preferencia = datos.preferencias.find(pref => pref.admitido);
      PdfDocument.setTituloDerecha(datos.periodo, true);
      PdfDocument.createTitle(datos, true);
      PdfDocument.createBannerEstado(datos, "RESULTADO_TIPO_A");
      PdfDocument.createPreferenciasResult(datos);
      PdfDocument.createBanner2(datos, "RESULTADO_TIPO_A");
      PdfDocument.createDatosEstablecimiento(preferencia.establecimiento);
      PdfDocument.createBannerPostulacionFamiliar();
      PdfDocument.createQRyTextoImportant(
        this.generarURLqr(),
        "RESULTADO_TIPO_A"
      );
      PdfDocument.createBannerInformacionFinal();
    },
    comprobanteAceptoMantenerEstablecimientoActual(datos, flag) {
      if (flag === true) {
        let preferencia = datos.preferencias.find(pref => pref.admitido);
        PdfDocument.setTituloDerecha(datos.periodo, true);
        PdfDocument.createTitle(datos, true);
        PdfDocument.createBannerEstado(
          datos,
          "RESULTADO_TIPO_A_ESTABLECIMIENTO_ACTUAL"
        );
        PdfDocument.createPreferenciasResult(datos);
        PdfDocument.createBanner2(
          datos,
          "RESULTADO_TIPO_A_ESTABLECIMIENTO_ACTUAL_BLOQUE"
        );
        PdfDocument.createDatosEstablecimiento(preferencia.establecimiento);
        PdfDocument.createBannerPostulacionFamiliar();
        PdfDocument.createQRyTextoImportant(
          this.generarURLqr(),
          "RESULTADO_TIPO_A_ESTABLECIMIENTO_ACTUAL"
        );
        PdfDocument.createBannerInformacionFinal();
      } else {
        let preferencia = datos.preferencias.find(pref => pref.admitido);
        PdfDocument.setTituloDerecha(datos.periodo, true);
        PdfDocument.createTitle(datos, true);
        PdfDocument.createBannerEstado(
          datos,
          "RESULTADO_TIPO_A_ESTABLECIMIENTO_ACTUAL"
        );
        PdfDocument.createPreferenciasResult(datos);
        PdfDocument.createBanner2(
          datos,
          "RESULTADO_TIPO_A_ESTABLECIMIENTO_ACTUAL"
        );
        PdfDocument.createDatosEstablecimiento(preferencia.establecimiento);
        PdfDocument.createBannerPostulacionFamiliar();
        PdfDocument.createQRyTextoImportant(
          this.generarURLqr(),
          "RESULTADO_TIPO_A_ESTABLECIMIENTO_ACTUAL"
        );
        PdfDocument.createBannerInformacionFinal();
      }
    },
    comprobanteAceptoResultadoYActivoListaEspera(datos) {
      let preferencia = datos.preferencias.find(pref => pref.admitido);
      PdfDocument.setTituloDerecha(datos.periodo, true);
      PdfDocument.createTitle(datos, true);
      PdfDocument.createBannerEstado(datos, "RESULTADO_TIPO_A_LISTA_ESPERA");
      PdfDocument.createPreferenciasResult(datos, true);
      PdfDocument.createBanner2(datos, "RESULTADO_LISTA_ESPERA_TIPO_A");
      PdfDocument.createDatosEstablecimiento(preferencia.establecimiento);
      PdfDocument.createBannerPostulacionFamiliar();
      PdfDocument.createQRyTextoImportant(
        this.generarURLqr(),
        "RESULTADO_TIPO_A"
      );
      PdfDocument.createBannerInformacionFinal();
    },
    comprobanteAceptoEstablecimientoActualYActivoListaEspera(datos) {
      let preferencia = datos.preferencias.find(pref => pref.admitido);
      PdfDocument.setTituloDerecha(datos.periodo, true);
      PdfDocument.createTitle(datos, true);
      PdfDocument.createBannerEstado(datos, "RESULTADO_TIPO_A_LISTA_ESPERA");
      PdfDocument.createPreferenciasResult(datos, true);
      PdfDocument.createBanner2(datos, "RESULTADO_TIPO_A_10");
      PdfDocument.createDatosEstablecimiento(preferencia.establecimiento);
      PdfDocument.createBannerPostulacionFamiliar();
      PdfDocument.createQRyTextoImportant(
        this.generarURLqr(),
        "RESULTADO_TIPO_A_ESTABLECIMIENTO_ACTUAL"
      );
      PdfDocument.createBannerInformacionFinal();
    },
    comprobanteRechazaEstablecimientoActual(datos) {
      PdfDocument.setTituloDerecha(datos.periodo, true);
      PdfDocument.createTitle(datos, true);
      PdfDocument.createBannerEstado(datos, "RESULTADO_TIPO_B");
      PdfDocument.createPreferenciasResult(datos, false, true);
      PdfDocument.createBanner2(datos, "RESULTADO_TIPO_B");
      PdfDocument.createBannerPostulacionFamiliar();
      PdfDocument.createQRyTextoImportant(
        this.generarURLqr(),
        "RESULTADO_TIPO_B"
      );
      PdfDocument.createBannerInformacionFinal();
    },
    comprobanteRechazaResultado(datos) {
      PdfDocument.setTituloDerecha(datos.periodo, true);
      PdfDocument.createTitle(datos, true);
      PdfDocument.createBannerEstado(datos, "RESULTADO_TIPO_B_2");
      PdfDocument.createPreferenciasResult(datos, false, true);
      PdfDocument.createBanner2(datos, "RESULTADO_TIPO_B_2");
      PdfDocument.createBannerPostulacionFamiliar();
      PdfDocument.createQRyTextoImportant(
        this.generarURLqr(),
        "RESULTADO_TIPO_B_2"
      );
      PdfDocument.createBannerInformacionFinal();
    },
    comprobanteListaEsperaAutomatica(datos) {
      PdfDocument.setTituloDerecha(datos.periodo, true);
      PdfDocument.createTitle(datos, true);
      PdfDocument.createBannerEstado(datos, "RESULTADO_TIPO_C");
      PdfDocument.createPreferenciasResult(datos, true);
      PdfDocument.createBanner2(datos, "RESULTADO_TIPO_C");
      PdfDocument.createBannerPostulacionFamiliar();
      PdfDocument.createQRyTextoImportant(
        this.generarURLqr(),
        "RESULTADO_TIPO_C"
      );
      PdfDocument.createBannerInformacionFinal();
    },
    comprobanteAdmitidoPreferenciaComplementario(datos) {
      let preferencia = datos.preferencias.find(pref => pref.admitido);
      PdfDocument.setTituloDerecha(datos.periodo, true);
      PdfDocument.createTitle(datos, true);
      PdfDocument.createBannerEstado(
        datos,
        "DATOS_RESULTADO_ADMITIDO_EN_PREFERENCIA"
      );
      PdfDocument.createPreferenciasResult(datos);
      PdfDocument.createBanner2(
        datos,
        "RESULTADOS_COMPLEMENTARIO_TOTAL_ASIG_PREF_N"
      );
      PdfDocument.createDatosEstablecimiento(preferencia.establecimiento);
      PdfDocument.createBannerPostulacionFamiliar();
      PdfDocument.createQRyTextoImportant(
        this.generarURLqr(),
        "RESULTADO_COMPLEMENTARIO_TIPO_A"
      );
      PdfDocument.createBannerInformacionFinal();
    },
    comprobanteAdmitidoMatriculaAseguradaComplementario(datos) {
      let preferencia = datos.preferencias.find(pref => pref.admitido);
      PdfDocument.setTituloDerecha(datos.periodo, true);
      PdfDocument.createTitle(datos, true);
      PdfDocument.createBannerEstado(
        datos,
        "MATRICULA_ASEGURADA_COMPLEMENTARIO"
      );
      PdfDocument.createPreferenciasResult(datos);
      PdfDocument.createBanner2(datos, "MATRICULA_ASEGURADA_COMPLEMENTARIO");
      PdfDocument.createDatosEstablecimiento(preferencia.establecimiento);
      PdfDocument.createBannerPostulacionFamiliar();
      PdfDocument.createQRyTextoImportant(
        this.generarURLqr(),
        "RESULTADO_COMPLEMENTARIO_TIPO_A"
      );
      PdfDocument.createBannerInformacionFinal();
    },
    comprobanteAdmitidoDistanciaComplementario(datos) {
      let preferencia = datos.preferencias.find(pref => pref.admitido);
      PdfDocument.setTituloDerecha(datos.periodo, true);
      PdfDocument.createTitle(datos, true);
      PdfDocument.createBannerEstado(datos, "ADMITIDO_POR_CERCANIA");
      PdfDocument.createPreferenciasResult(datos);
      PdfDocument.createBanner2(datos, "ADMITIDO_POR_CERCANIA_COMPLEMENTARIO");
      PdfDocument.createDatosEstablecimiento(preferencia.establecimiento);
      PdfDocument.createBannerPostulacionFamiliar();

      PdfDocument.createQRyTextoImportant(
        this.generarURLqr(),
        "RESULTADO_COMPLEMENTARIO_TIPO_B"
      );
      PdfDocument.createBannerInformacionFinal();
    },
    comprobanteSinAsignacionComplementario(datos) {
      PdfDocument.setTituloDerecha(datos.periodo, true);
      PdfDocument.createTitle(datos, true);
      PdfDocument.createBannerEstado(datos, "RESULTADO_COMPLEMENTARIO_TIPO_B");
      PdfDocument.createBanner2(datos, "SIN_ASIGNACION_COMPLEMENTARIO");
      PdfDocument.createQRyTextoImportant(
        this.generarURLqr(),
        "RESULTADO_COMPLEMENTARIO_TIPO_B"
      );
    },
    comprobanteSinAsignacionPeriodosAnterioresNoParticiaComplementario(datos) {
      PdfDocument.setTituloDerecha(datos.periodo, true);
      PdfDocument.createTitle(datos, true);
      PdfDocument.createBannerEstado(datos, "RESULTADO_COMPLEMENTARIO_TIPO_B");
      PdfDocument.createBannerPostulacionFamiliar();
      PdfDocument.createQRyTextoImportant(
        this.generarURLqr(),
        "RESULTADO_COMPLEMENTARIO_TIPO_B"
      );
      PdfDocument.createBannerInformacionFinal();
    },
    comprobantePorOmision(datos, flag) {
      let datosComprobante = {
        titulo: "DATOS RESULTADO ACEPTADO POR OMISIÓN",
        tipo: "porOmision",
        tipoDetalle: "porOmision",
        preferenciaAdmitido: datos.preferencias.find(pref => pref.admitido),
        listaDeEspera: datos.preferencias.filter(
          pref => pref.glosaEstado === "LISTA_DE_ESPERA"
        ),
        postulante: datos.postulante,
        periodo: datos.periodo
      };

      PdfDocument.setTituloDerecha(datos.periodo, true);
      PdfDocument.createTitle(datos, true);
      PdfDocument.createBannerEstado(datos, "RESULTADO_DEFAULT");
      PdfDocument.createPreferenciasResult(datos);
      PdfDocument.createDatosEstablecimiento(
        datosComprobante.preferenciaAdmitido.establecimiento
      );
      PdfDocument.createBannerPostulacionFamiliar();
      PdfDocument.createQRyTextoImportant(
        this.generarURLqr(),
        "RESULTADO_DEFAULT"
      );
      PdfDocument.createBannerInformacionFinal();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/resultados/Descargar.vue